<form [formGroup]="dateForm" class="tablelist-form" autocomplete="off">
  <label for="date-field" class="form-label">{{title}}</label>
  @if (yearSelector) {
    <select
      class="form-select"
      [disabled]="disable ?? false"
      [(ngModel)]="yearSelectorValue"
      [ngModelOptions]="{ standalone: true }"
      (change)="selectOnChange()">
      <option [ngValue]="undefined">Select</option>
      @for (year of yearSelectorOptions; track year) {
        <option [ngValue]="year">{{ year }}</option>
      }
    </select>
  } @else if (monthSelector) {
    <input #flatpickrMonthOnly
      class="form-select"
      placeholder="Select"
      type="text"
      (change)="selectOnChange()">
  } @else {
    <div
      class="input-group"
      [class.input-group-disabled]="dateForm.controls['date'].disabled"
    >
      <input #flatpickr #flatpickrDirective="mwlFlatpickr"
        [allowInput]="true"
        [altInput]="true"
        [altFormat]="dateFormat ?? 'F j, Y'"
        [altInputClass]="'form-control flatpickr-input'"
        class="form-control flatpickr-input"
        [dateFormat]="enableTime ? 'Y-m-d H:i' : 'Y-m-d'"
        [enableTime]="enableTime"
        [time24hr]="true"
        [convertModelValue]="true"
        formControlName="date"
        id="date-field"
        mwlFlatpickr
        placeholder="dd/mm/yyyy"
        type="text"
        (flatpickrChange)="selectOnChange()"
        (flatpickrValueUpdate)="selectOnChange()">
      <div
        class="input-group-text"
        [ngClass]="dateForm.controls['date'].disabled
          ? 'bg-light border-secondary text-muted'
          : 'bg-primary border-primary text-white'"
      >
        <i class="ri-calendar-2-line"></i>
      </div>
    </div>
  }
</form>
